// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__tYkwj","form":"LoginForm_form__q+o3Y","forgotPassword":"LoginForm_forgotPassword__h0qZ7"};